// ProtectedRoute — wraps any route that requires a signed-in user.
//
// While the AuthProvider is still resolving the session, we render a
// quiet "loading" state rather than redirecting — otherwise a real
// session would be redirected to /login before the cookie is hydrated.

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { MockingbirdLoader } from "@/components/ui/mockingbird-loader";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="grid min-h-full place-items-center px-6">
        <MockingbirdLoader screen label="Mockingbird is opening your workspace..." />
      </main>
    );
  }

  if (!session) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
